import axios from 'axios';
import { actions as sessionActions } from '@clearscore/redux.session';
import {
    clientDirectory,
    getAuth,
    handleErroneousResponseInterceptor,
} from '@shared/external-cs-auth.add-client-instance';
import interpolateWithMarket from '@clearscore/helpers.interpolate-with-market';
import monitoring from '@clearscore/helpers.monitoring';

const getInterpolatedUrl = (baseURL, state, requestMeta) => {
    const isFunction = (config) => typeof config === 'function';

    const url = isFunction(baseURL) ? baseURL(state) : baseURL;

    return baseURL
        ? interpolateWithMarket({
              state,
              url,
              market: requestMeta ? requestMeta.market : null,
          })
        : null;
};

export default async (state, store, requestMeta) => {
    const headers = getAuth('international');
    const config = {
        ...clientDirectory.international,
        baseURL: getInterpolatedUrl(clientDirectory.international.baseURL, state, requestMeta),
    };
    const instance = axios.create(config);
    instance.interceptors.response.use(
        (response) => response,
        async (error) => handleErroneousResponseInterceptor(error, store, instance, requestMeta, true),
    );

    await instance
        .post('/login-service/v3/logout', {}, { headers })
        .catch(() => monitoring.log('Error when trying to logout via the login-service'));

    if (store) return store.dispatch(sessionActions.logout());
    return sessionActions.logout();
};

export * from './message';
